import { h } from 'preact';

const CloseButtonWithCircle = (props) => (
    <div class='close-button-with-circle' onClick={props.action}>
       <img src='img/icon-close-x.svg' alt='close' />
    </div>
)

export default CloseButtonWithCircle;



// WEBPACK FOOTER //
// ./src/scripts/views/tags/close-button-with-circle.js